import { Box, Theme, styled } from '@mui/material'

export const dashboardBoxStyle = (theme: Theme, isSideNavOpen: boolean) => {
  return {
    width: '100%',
    height: '100%',
    transition: theme.transitions.create(['all'], {
      duration: theme.transitions.duration.short,
      easing: theme.transitions.easing.easeInOut
    }),
    [theme.breakpoints.down('lg')]: {
      marginLeft: 0,
      '&::before': {
        content: '""',
        position: 'fixed',
        display: 'block',
        top: 0,
        left: 0,
        width: !isSideNavOpen ? '100%' : 0,
        height: !isSideNavOpen ? '100%' : 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 10
      }
    }
  }
}
// export const dashboardBoxStyle = (theme: Theme, isSideNavOpen: boolean) => {
//   return {
//     marginLeft: !isSideNavOpen ? '250px' : '60px',
//     marginTop: '70px',
//     transition: theme.transitions.create(['all'], {
//       duration: theme.transitions.duration.short,
//       easing: theme.transitions.easing.easeInOut
//     }),
//     [theme.breakpoints.down('xl')]: {
//       marginLeft: !isSideNavOpen ? '200px' : '60px'
//     },
//     [theme.breakpoints.down('lg')]: {
//       marginLeft: 0,
//       '&::before': {
//         content: '""',
//         position: 'fixed',
//         display: 'block',
//         top: 0,
//         left: 0,
//         width: !isSideNavOpen ? '100%' : 0,
//         height: !isSideNavOpen ? '100%' : 0,
//         backgroundColor: 'rgba(0, 0, 0, 0.5)',
//         zIndex: 10
//       }
//     }
//   }
// }
